import {
  IN_AREA_CAR_BOOKINGS_FETCHING,
  IN_AREA_CAR_BOOKINGS_FAILED,
  IN_AREA_CAR_BOOKINGS_SUCCESS,
} from "../../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case IN_AREA_CAR_BOOKINGS_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case IN_AREA_CAR_BOOKINGS_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case IN_AREA_CAR_BOOKINGS_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
